import React from 'react';

import { PeosListQueryVariables, PeoWhere } from 'src/api';
import { useFilterStorage, useSearchQueryVariables } from 'src/hooks/common';
import { useCurrentPeoPayrollProviderStaff } from 'src/hooks/peoPayrollProviderStaff';
import { preparePeosFilterByStatus } from 'src/utils/peo';

export const usePeosUnderPeoPpListQueryVariables = (peoPayrollProviderID?: string) => {
  const { peoPayrollProviderId: peoPayrollProviderIdFromUser } =
    useCurrentPeoPayrollProviderStaff();

  const peoPayrollProviderId = peoPayrollProviderID ?? peoPayrollProviderIdFromUser;

  const { filter, sortQueryVariable, paginationQueryVariables } = useFilterStorage();

  const filterQueryVariables = preparePeosFilterByStatus(filter);
  const searchQueryVariables = useSearchQueryVariables(['displayName']);

  const queryFilter: PeoWhere = React.useMemo(() => {
    return {
      peoPayrollProviderId: { equals: peoPayrollProviderId },
      ...searchQueryVariables,
      ...filterQueryVariables,
    };
  }, [filterQueryVariables, peoPayrollProviderId, searchQueryVariables]);

  const queryVariables: PeosListQueryVariables = React.useMemo(() => {
    return {
      filter: queryFilter,
      sort: sortQueryVariable,
      ...paginationQueryVariables,
    };
  }, [paginationQueryVariables, queryFilter, sortQueryVariable]);

  return { queryFilter, sortQueryVariable, paginationQueryVariables, queryVariables };
};
